import { api, API_URL } from './client.js';

export const listStories       = ()        => api.get('/stories');
export const listPublicStories = ()        => api.get('/stories/public');
export const getStory          = (id)      => api.get(`/stories/${id}`);
export const createStory       = (payload) => api.post('/stories', payload);
export const updateStory       = (id, body)=> api.put(`/stories/${id}`, body);
export const deleteStory       = (id)      => api.del(`/stories/${id}`);
export const shareStory        = (id)      => api.post(`/stories/${id}/share`);
export const unshareStory      = (id)      => api.post(`/stories/${id}/unshare`);

/** Anonymous read via public token (no Authorization header needed). */
export async function getPublicStory(token) {
  const resp = await fetch(`${API_URL}/public/stories/${token}`);
  if (!resp.ok) throw new Error(`Story not found (${resp.status})`);
  return resp.json();
}
